import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class filterArticle_template extends vnTemplate {

    protected delay = 400;
    protected debounceTimerId: number;

    protected getTemplateHtml(): string {

        return `
                <div class="w-spec-search long icon i-auto-complete i-article-a">
                    <input data-bind="textInput: article, event: { keyup: onChangeInput}, valueUpdate : 'afterkeydown', attr:{id:idArticle}" list="articles" class="input-text" placeholder="Articles">
                        <ul class="form-auto-list" data-bind="foreach: articles, visible: isShowArticleSuggestions" id="articles">
                            <li class="form-auto-item" data-bind="attr:{id:id}, text: $data.title, css: iconImage, click: $parent.onBlurArticle" ></li>
                        </ul>
                    </input>
                    <button data-bind="event: { click: onClearInput }, class: article() != '' ? 'close-btn icon i-x-after is-showing': 'close-btn icon i-x-after'" id="article-input-close" type="button"><span class="hidden-text">close</span></button>
                </div>
                `;
    }

    protected getTemplateName(): string {
        return "filterArticle-template";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            articles: ko.observableArray([])
            , idArticle: ko.observable(null)
            , idBrand: ko.observable(null)
            , article: ko.observable("")
            , articleObjLite: ko.observable("") // A stripped down version of articleObj that only contains title, idBrand and idArticle.
            , articleObj: ko.observable(null)
            , orderBy: "dateCreation"
            , orderByDirection: "DESC"
            , isShowArticleSuggestions: ko.observable(false)
            , closeButtonClasses: ko.observable("close-btn icon i-x-after")
            , onChangeInput: function (data, event) {
                huit_neuf_this.onChangeInput(data, event);
            }
            , onClearInput: function (data, event) {
                huit_neuf_this.onClearInput(event);
            }
            , onChangeFilterAction: function (data, event) {
                huit_neuf_this.onChangeFilterAction(data)
            }
            , onBlurArticle: function (data, event) {
                huit_neuf_this.onBlurArticle(data, event);
            }
        };
    }

    protected onChangeFilterAction(data) {
        this.caller.filterSimpleOnChange(this.idElement);
    }

    protected onChangeInput(data, event) {

        clearTimeout(this.debounceTimerId);

        this.getTemplateViewModel().closeButtonClasses('close-btn icon i-x-after is-showing');
        let _myThis = this;
        this.debounceTimerId = window.setTimeout(function(){

            _myThis.onChangeArticleDataListArticle(event, _myThis.getTemplateViewModel().idArticle);
        }, this.delay);
    }

    protected onChangeArticleDataListArticle(event, idArticle) {
        let input = event.target,
            inputVal = input.value,
            optionsList = input.getAttribute('list'),
            options: any = document.getElementById("articles").childNodes;
        if (inputVal.length >= 3) {
            this.caller.getArticlesSuggestion(inputVal, this.idElement);
            this.getTemplateViewModel().isShowArticleSuggestions(true);

        }
        for (let op of options) {
            if (op.value === inputVal) {
                idArticle(op.idArticle);
                input.blur();
                this.caller.filterSimpleOnChange(this.idElement);
                break;
            }
        }
    }

    protected onClearInput(event) {
        this.getTemplateViewModel().closeButtonClasses('close-btn icon i-x-after');
        this.viewModel[this.idElement].idArticle(null);
        this.viewModel[this.idElement].article("");
        this.viewModel[this.idElement].articleObj("");
        this.viewModel[this.idElement].articleObjLite("");
        this.caller.filterSimpleOnChange(this.idElement);
        this.getTemplateViewModel().isShowArticleSuggestions(false);
    }

    protected onBlurArticle(data, event) {
        this.getTemplateViewModel().article(data.title)
        this.getTemplateViewModel().articleObj(data)
        this.getTemplateViewModel().articleObjLite({

            title: data.title,
            idArticle: data.idArticle,
            idBrand: data.idBrand,
        })
        this.getTemplateViewModel().idArticle(data.idArticle);
        this.getTemplateViewModel().isShowArticleSuggestions(false);
        this.caller.filterSimpleOnChange(this.idElement);
    }

    public setViewModelFromRequest(article){

        if(typeof article !== 'undefined' && article !== null && typeof article === 'object' && article.title != '' && article.idBrand != null && article.idArticle != null) {

            let articleLite = {'title': article.title, 'idBrand': article.idBrand, 'idArticle': article.idArticle};

            this.getTemplateViewModel().article(articleLite.title);
            this.getTemplateViewModel().idBrand(articleLite.idBrand);
            this.getTemplateViewModel().idArticle(articleLite.idArticle);
            this.getTemplateViewModel().articleObj(articleLite);
            this.getTemplateViewModel().articleObjLite(articleLite);
        }else{
            this.getTemplateViewModel().article('');
            this.getTemplateViewModel().idBrand(null);
            this.getTemplateViewModel().idArticle(null);
            this.getTemplateViewModel().articleObj(null);
            this.getTemplateViewModel().articleObjLite(null);
        }

        this.getTemplateViewModel().isShowArticleSuggestions(false)
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/filterArticle_template.ts